import { render, staticRenderFns } from "./SectionDivisionDetail.vue?vue&type=template&id=1b0d81c6&scoped=true&"
import script from "./SectionDivisionDetail.vue?vue&type=script&lang=js&"
export * from "./SectionDivisionDetail.vue?vue&type=script&lang=js&"
import style0 from "./SectionDivisionDetail.vue?vue&type=style&index=0&id=1b0d81c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0d81c6",
  null
  
)

export default component.exports